module.exports = __webpack_public_path__ + "img/qualityIndexScore2.cb6539c4.png";